<template>
  <div>
   <div v-if="reviews && reviews.length">
            <review-item
              v-for="(review, index) in reviews"
              :item="review"
              :key="index"
            ></review-item>
          </div>
          <div v-else>
              <empty-data iconColor="#444" :message="$t('empty.reviews')" icon="k-icon-star" textColor="#000" ></empty-data>
          </div>
    
  </div>
</template>
<script>
import { helpers } from "@/utilities";
import { mapActions, mapState } from "vuex";
import ReviewItem from "./ReviewItem";
import EmptyData  from "./EmptyData";

export default {
  name: "reviews-modal",
  components: {
      ReviewItem,
      EmptyData
  },
  computed: {
      ...mapState({
      reviews: state => state.locationReviews,
    }),
  },
  data() {
    return {
      getHelpers: helpers,
      isMounted: false,
      shown: false
    };
  },
  methods: {
    ...mapActions(["fetchLocationReviews"]),
  },
  created() {
    if (!this.isLocationEmpty())
      this.fetchLocationReviews(this.selectedLocation.id)

  },
  mounted() {
    this.isMounted = true;
  }
};
</script>